import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Sheet, SheetOverlay, SheetContent } from '@wartek-id/sheet-v1'
import { Text } from '@wartek-id/text'

import useConversation from 'app/ConversationPage/hooks/useConversation'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import { AbortRequestService } from 'app/ConversationPage/utils/api'

interface INewSessionConfirmSheetProps {
  isOpen: boolean
  onClose: () => void
}
const NewSessionConfirmSheet: React.FC<INewSessionConfirmSheetProps> = ({
  isOpen,
  onClose,
}) => {
  const { resetSession } = useConversation()
  const { SETrackConversationPage } = useSETrackEvent()
  const abortController = AbortRequestService.getInstance()

  const confirmHandler = () => {
    abortController.abortRequest()
    resetSession()
    onClose()

    SETrackConversationPage('GURU_AI_PAGE', {
      is_new_ai_chat_session: [false, 'bool'],
      ai_chat_session_id: null,
    })
  }

  return (
    <Sheet autoFocus={false} isOpen={isOpen} closeOnOverlayClick>
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <div className="p-4">
          <div className="mb-2">
            <Text variant="heading-md">
              Diskusi ini tidak bisa Anda akses lagi kalau Anda mulai diskusi
              baru. Tangkap layar/salin dulu, yuk
            </Text>
          </div>

          <div className="mb-6">
            <Text color="subdued">Pastikan Anda simpan info penting.</Text>
          </div>

          <div className="space-y-2">
            <Button color="black" fullWidth onClick={confirmHandler}>
              Langsung mulai diskusi baru
            </Button>
            <Button color="white" fullWidth onClick={onClose}>
              Batalkan
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default NewSessionConfirmSheet
